"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelMapper = exports.ModelResponseTypes = exports.Subscription = exports.HabitJourney = exports.Badge = exports.Statistic = exports.Audio = exports.Video = exports.User = exports.Segment = exports.Phase = exports.Page = exports.Option = exports.ImageObject = exports.Image = exports.Habit = exports.Container = exports.Component = exports.Bullet = exports.BaseModel = exports.BadgeValue = exports.Answer = exports.AccountSegment = exports.AccountHabit = exports.Account = void 0;
const lodash_1 = require("lodash");
const account_1 = __importDefault(require("./account"));
exports.Account = account_1.default;
const account_habit_1 = __importDefault(require("./account-habit"));
exports.AccountHabit = account_habit_1.default;
const account_segment_1 = __importDefault(require("./account-segment"));
exports.AccountSegment = account_segment_1.default;
const answer_1 = __importDefault(require("./answer"));
exports.Answer = answer_1.default;
const audio_1 = __importDefault(require("./audio"));
exports.Audio = audio_1.default;
const badge_1 = __importDefault(require("./badge"));
exports.Badge = badge_1.default;
const badge_value_1 = __importDefault(require("./badge-value"));
exports.BadgeValue = badge_value_1.default;
const base_1 = __importDefault(require("./base"));
exports.BaseModel = base_1.default;
const bullet_1 = __importDefault(require("./bullet"));
exports.Bullet = bullet_1.default;
const component_1 = __importDefault(require("./component"));
exports.Component = component_1.default;
const container_1 = __importDefault(require("./container"));
exports.Container = container_1.default;
const habit_1 = __importDefault(require("./habit"));
exports.Habit = habit_1.default;
const habit_journey_1 = __importDefault(require("./habit-journey"));
exports.HabitJourney = habit_journey_1.default;
const image_1 = __importDefault(require("./image"));
exports.Image = image_1.default;
const image_object_1 = __importDefault(require("./image-object"));
exports.ImageObject = image_object_1.default;
const option_1 = __importDefault(require("./option"));
exports.Option = option_1.default;
const page_1 = __importDefault(require("./page"));
exports.Page = page_1.default;
const phase_1 = __importDefault(require("./phase"));
exports.Phase = phase_1.default;
const segment_1 = __importDefault(require("./segment"));
exports.Segment = segment_1.default;
const statistic_1 = __importDefault(require("./statistic"));
exports.Statistic = statistic_1.default;
const subscription_1 = __importDefault(require("./subscription"));
exports.Subscription = subscription_1.default;
const user_1 = __importDefault(require("./user"));
exports.User = user_1.default;
const video_1 = __importDefault(require("./video"));
exports.Video = video_1.default;
const ModelClasses = {
    User: user_1.default,
    Image: image_1.default,
    Account: account_1.default,
    Habit: habit_1.default,
    AccountHabit: account_habit_1.default,
};
// @ts-ignore
exports.ModelResponseTypes = Object.keys(ModelClasses).reduce((acc, curr) => {
    // @ts-ignore
    acc[curr] = curr;
    return acc;
}, {});
function modelMapper(object, modelResponseType) {
    const ModelClass = ModelClasses[modelResponseType];
    if (ModelClass) {
        // @ts-ignore
        const { data, meta } = object;
        if ((0, lodash_1.isArray)(data)) {
            // @ts-ignore
            const hydrated = data.length > 0 ? data.map((item) => new ModelClass(item)) : [];
            return {
                data: hydrated,
                meta: meta || null,
            };
        }
        return {
            // @ts-ignore
            data: new ModelClass(data || object),
            meta: null,
        };
    }
    // eslint-disable-next-line
    console.warn('Response was read without a valid Response Type', object);
    return object;
}
exports.modelMapper = modelMapper;
